import React from 'react';
import { Link } from 'react-router-dom';
import { useCookieConsent } from '../contexts/CookieConsentContext';
import './CookieBanner.css';

const CookieBanner = () => {
  const { showBanner, acceptAll, rejectAll, openSettings } = useCookieConsent();

  if (!showBanner) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-label="Cookie consent" aria-describedby="cookie-banner-desc">
      <div className="cookie-banner-content">
        <div className="cookie-banner-text">
          <h3 className="cookie-banner-title">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <circle cx="8" cy="9" r="1" fill="currentColor"/>
              <circle cx="15" cy="8" r="1" fill="currentColor"/>
              <circle cx="10" cy="14" r="1" fill="currentColor"/>
              <circle cx="16" cy="13" r="1" fill="currentColor"/>
              <circle cx="13" cy="17" r="1" fill="currentColor"/>
            </svg>
            We use cookies
          </h3>
          <p className="cookie-banner-desc" id="cookie-banner-desc">
            We use cookies to serve personalized content and analyze our traffic.
            You can choose which cookies you allow.
          </p>
          <Link to="/privacy#cookies" className="cookie-banner-policy-link">
            Read our Cookie Policy
          </Link>
        </div>
        <div className="cookie-banner-actions">
          <button className="cookie-btn cookie-btn-reject" onClick={rejectAll}>
            Reject All
          </button>
          <button className="cookie-btn cookie-btn-settings" onClick={openSettings}>
            Cookie Settings
          </button>
          <button className="cookie-btn cookie-btn-accept" onClick={acceptAll}>
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
